import { Utility, utility_controller, getTargetContainers, getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import { load_visible_images_then_rest_controller } from '../utility/load_visible_images_then_rest'
import restoreLoadMore from '../utility/restoreLoadMore'

import union from 'lodash/union'
import intersection from 'lodash/intersection'

var $grids

var getRowsToShow = function (config, device) {
	if (!config || !device) {
		return 0
	}
	var rows = config[device] && typeof config[device].rowsToShow !== 'undefined' ? Number(config[device].rowsToShow) : 0
	if (isNaN(rows) || rows < 0) {
		rows = 0
	}
	return rows
}

var getLimitForDevice = function (config, device) {
	var rows = getRowsToShow(config, device)
	if (rows <= 0) {
		return -1
	}
	var colCount = config[device] && typeof config[device].colCount !== 'undefined' ? Number(config[device].colCount) : 1
	if (isNaN(colCount) || colCount < 1) {
		colCount = 1
	}
	return rows * colCount
}

var getRowsShownMultiplier = function ($grid) {
	var attr = Number($grid.attr('data-rows-shown'))
	if (isNaN(attr) || attr < 1) {
		attr = 1
		$grid.attr('data-rows-shown', attr)
	}
	return attr
}

var setRowsShownMultiplier = function ($grid, value) {
	if (isNaN(value) || value < 1) {
		value = 1
	}
	$grid.attr('data-rows-shown', value)
}

var resetRowsShownMultiplier = function ($grid) {
	setRowsShownMultiplier($grid, 1)
}

var applyRowLimit = function ($grid, config) {
	if (!$grid || $grid.length === 0 || !config) {
		return
	}
	var showMoreEnabled = config.showMoreButton === true || config.showMoreButton === 'true'
	var rowsToShow = getRowsToShow(config, Utility.screenSize)
	// Button can be inside the grid or as a sibling (inside parent container)
	var $buttonWrap = $grid.find('.lay-productsgrid-load-more-wrap').first()
	if ($buttonWrap.length === 0) {
		// Button is likely a sibling of the grid, look in parent container
		$buttonWrap = $grid.parent().find('.lay-productsgrid-load-more-wrap').first()
	}
	if ($buttonWrap.length === 0) {
		// Try finding it as a next sibling
		$buttonWrap = $grid.nextAll('.lay-productsgrid-load-more-wrap').first()
	}
	if ($buttonWrap.length === 0) {
		// Try finding it in the closest .col container
		$buttonWrap = $grid.closest('.col').find('.lay-productsgrid-load-more-wrap').first()
	}
	var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-productsgrid-load-more').first() : jQuery()
	if (!showMoreEnabled || rowsToShow <= 0) {
		if ($button.length) {
			$button.hide()
		}
		resetRowsShownMultiplier($grid)
		$grid.find('.lay-product.hide-loadmore').removeClass('hide-loadmore')
		return
	}
	var multiplier = getRowsShownMultiplier($grid)
	var colCount = config[Utility.screenSize] && typeof config[Utility.screenSize].colCount !== 'undefined' ? Number(config[Utility.screenSize].colCount) : 1
	if (isNaN(colCount) || colCount < 1) {
		colCount = 1
	}
	var maxVisible = rowsToShow * colCount * multiplier
	var visibleCount = 0
	$grid.find('.lay-product.hide-loadmore').removeClass('hide-loadmore')
	// Count only items that are not filtered out
	var totalUnfilteredCount = 0
	$grid.find('.lay-product').each(function () {
		var $item = jQuery(this)
		if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit')) {
			totalUnfilteredCount++
		}
	})
	$grid.find('.lay-product').each(function () {
		var $item = jQuery(this)
		if ($item.hasClass('hide-filtered') || $item.hasClass('hide-because-limit')) {
			return
		}
		if (visibleCount < maxVisible) {
			visibleCount++
			$item.removeClass('hide-loadmore')
		} else {
			$item.addClass('hide-loadmore')
		}
	})
	if ($button.length) {
		// Show button only if there are more unfiltered items than currently visible
		if (totalUnfilteredCount > visibleCount) {
			// Remove inline display:none styles by setting display to empty string
			$button.css('display', '')
			// Explicitly show the button
			$button.show()
		} else {
			$button.hide()
		}
	}
	if (config.layoutType === 'masonry') {
		var masonry = $grid.data('masonry')
		if (typeof masonry != 'undefined' && masonry !== null) {
			masonry.reloadItems()
			masonry.layout()
			// Re-evaluate button visibility after masonry layout completes
			// Only update button visibility, don't call applyRowLimit again (would cause infinite loop)
			masonry.once('layoutComplete', function () {
				var $buttonWrap = $grid.find('.lay-productsgrid-load-more-wrap').first()
				if ($buttonWrap.length === 0) {
					$buttonWrap = $grid.parent().find('.lay-productsgrid-load-more-wrap').first()
				}
				if ($buttonWrap.length === 0) {
					$buttonWrap = $grid.nextAll('.lay-productsgrid-load-more-wrap').first()
				}
				if ($buttonWrap.length === 0) {
					$buttonWrap = $grid.closest('.col').find('.lay-productsgrid-load-more-wrap').first()
				}
				var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-productsgrid-load-more').first() : jQuery()
				if ($button.length) {
					var totalUnfilteredCount = 0
					var visibleCount = 0
					$grid.find('.lay-product').each(function () {
						var $item = jQuery(this)
						if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit')) {
							totalUnfilteredCount++
						}
						if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit') && !$item.hasClass('hide-loadmore')) {
							visibleCount++
						}
					})
					if (totalUnfilteredCount > visibleCount) {
						$button.show()
					} else {
						$button.hide()
					}
				}
			})
		}
	}
}

var i = function () {
	jQuery(window).on('window_width_changed', onResize)
	// otherwise, masonry doesnt position elements correctly for scrollslider:
	window.laytheme.on('scrollslider-initialized', onResize)
	bindOnContentReady()
	bindPageOverlayEvents()
	bindOnHashChange()
}

var handleHashChange = function () {
	var hash = window.location.hash

	if ($target != undefined) {
		var $grids = $target.find('.lay-products-thumbnails-grid.use-filter')

		if ($grids.length > 0) {
			$grids.each(function () {
				var $grid = jQuery(this)
				deselectTags($grid)
				var cat_id = false
				var thumbnails_show_hide_data = []
				if (hash.startsWith('#product-category-')) {
					var slug = hash.substring(18)
					var $filter = jQuery(this.parentNode).find('[data-slug="' + slug + '"]')

					if ($filter.length > 0) {
						cat_id = $filter.attr('data-id')
						thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
						filterContent($grid, cat_id, true, thumbnails_show_hide_data)
					}
				} else if (hash == '') {
					// back to default filter!
					var $filter = jQuery('.lay-filter-default')
					if ($filter.length > 0) {
						cat_id = $filter.attr('data-id')
						thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
						filterContent($grid, cat_id, true, thumbnails_show_hide_data)
					}
				}
				if (cat_id !== false) {
					showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
				}
			})
		}
		// a hash change means we filtered by category.
		// now we need to deselect all tags and hide tags that have no content to be filtered
	}
}

var bindOnHashChange = function () {
	jQuery(window).on('hashchange', handleHashChange)
}

var showHideTagBubbles = function ($grid, cat_id, thumbnails_show_hide_data) {
	if (Array.isArray(cat_id)) {
		for (var index = 0; index < cat_id.length; index++) {
			cat_id[index] = parseInt(cat_id[index], 10)
		}
	} else if (cat_id !== false) {
		cat_id = [parseInt(cat_id, 10)]
	}
	var $col = $grid.closest('.col')
	var config = $grid.data('config')

	var showCatFilter = false
	if (config != false && config.hasOwnProperty('showfilter') && config.showfilter != null) {
		showCatFilter = config.showfilter
	}
	var tagFilterBehaviour = 'OR'
	if (config != false && config.hasOwnProperty('tagFilterBehaviour') && config.tagFilterBehaviour != null) {
		tagFilterBehaviour = config.tagFilterBehaviour
	}
	var showtagfilter = false
	if (config != false && config.hasOwnProperty('showtagfilter') && config.showtagfilter != null) {
		showtagfilter = config.showtagfilter
	}

	var all_available_tag_ids_for_current_cat = []
	if (showCatFilter == true) {
		// hide bubbles that have no content in grid that could be filtered
		$grid.find('.lay-product>a').each(function () {
			var thumbnail_category_ids_string = jQuery(this).attr('data-catid')
			var thumbnail_category_ids = utility_controller.parseIdsString(thumbnail_category_ids_string)
			if (cat_id !== false) {
				var isCatMember = intersection(thumbnail_category_ids, cat_id).length > 0
				if (isCatMember) {
					var thumbnail_tag_ids_string = jQuery(this).attr('data-tags')
					var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
					for (var index = 0; index < thumbnail_tag_ids.length; index++) {
						var id = thumbnail_tag_ids[index]
						if (all_available_tag_ids_for_current_cat.indexOf(id) == -1) {
							all_available_tag_ids_for_current_cat.push(id)
						}
					}
				}
			}
		})
	} else if (showtagfilter == true && showCatFilter == false) {
		// there is no category filter so just remove tag filters that we dont need from dom
		$grid.find('.lay-product>a').each(function () {
			var thumbnail_tag_ids_string = jQuery(this).attr('data-tags')
			var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
			for (var index = 0; index < thumbnail_tag_ids.length; index++) {
				var id = thumbnail_tag_ids[index]
				if (all_available_tag_ids_for_current_cat.indexOf(id) == -1) {
					all_available_tag_ids_for_current_cat.push(id)
				}
			}
		})

		$col.find('.ptag-bubble:not(.deselect-tags)').each(function () {
			var tag_id = parseInt(jQuery(this).attr('data-tag_id'), 10)
			if (all_available_tag_ids_for_current_cat.indexOf(tag_id) == -1) {
				jQuery(this).remove()
			}
		})
	}

	var $activeBubbles = $col.find('.ptag-bubble.lay-tag-active')
	if ($activeBubbles.length > 0) {
		// show "clear all" button
		$col.find('.deselect-tags').css('display', '').removeClass('lay-filter-hidden')
	} else {
		$col.find('.deselect-tags').addClass('lay-filter-hidden')
	}

	switch (tagFilterBehaviour) {
		case 'AND':
			// when tagFilterBehaviour is "AND" and at least one tag bubble is selected,
			// only show tag bubbles that would create results when clicked on / combined with currently selected tag(s)
			// first: get currently selected tag ids

			var $activeBubbles = $col.find('.ptag-bubble.lay-tag-active')
			if ($activeBubbles.length > 0) {
				var activeTagIds = []
				$activeBubbles.each(function () {
					activeTagIds.push(parseInt(jQuery(this).attr('data-tag_id'), 10))
				})

				// then look at the currently filtered thumbnails. which tag ids do they have?

				var tagIdsOfCurrentlyFilteredThumbnails = []
				for (var index = 0; index < thumbnails_show_hide_data.length; index++) {
					var obj = thumbnails_show_hide_data[index]
					if (obj.show == true) {
						tagIdsOfCurrentlyFilteredThumbnails = union(obj.ids, tagIdsOfCurrentlyFilteredThumbnails)
					}
				}

				for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
					var tag_id = all_available_tag_ids_for_current_cat[index]

					if (activeTagIds.length > 0 && intersection(activeTagIds, tagIdsOfCurrentlyFilteredThumbnails).length > 0 && tagIdsOfCurrentlyFilteredThumbnails.indexOf(tag_id) != -1) {
						$col.find('.ptag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
					} else {
						$col.find('.ptag-bubble[data-tag_id="' + tag_id + '"]').css('display', 'none')
					}
				}
			} else {
				// re-show bubbles that were hidden previously
				$col.find('.ptag-bubble:not(.deselect-tags)').css('display', 'none')

				for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
					var tag_id = all_available_tag_ids_for_current_cat[index]

					$col.find('.ptag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
				}
			}
			break
		case 'OR':
		default:
			if (showCatFilter) {
				$col.find('.ptag-bubble:not(.deselect-tags)').css('display', 'none')
				for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
					var tag_id = all_available_tag_ids_for_current_cat[index]
					$col.find('.ptag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
				}
			}
			break
	}
}

var deselectTags = function ($grid, $tag_bubble) {
	var $col = $grid.closest('.col')
	var $tags_wrap = $col.find('.lay-productsgrid-tagfilter')

	if ($tag_bubble != undefined && $tag_bubble != false && $tag_bubble.length > 0) {
		// deselect one tag
		$tag_bubble.removeClass('lay-tag-active')
	} else {
		// deselect all tags
		$col.find('.ptag-bubble').removeClass('lay-tag-active')
	}
	// sort:
	// https://stackoverflow.com/a/282940
	var $bubbles = $tags_wrap.find('.ptag-bubble')
	var itemsArr = []
	var config = $grid.data('config')
	var reorder_tags = config != false && config.hasOwnProperty('reorder_tags') ? config.reorder_tags : true
	if (reorder_tags) {
		$bubbles.each(function () {
			// var innerHTML = jQuery(this).innerHTML;

			if (!jQuery(this).hasClass('lay-tag-active')) {
				var ix = jQuery(this).attr('data-ix')
				itemsArr.push([this, ix])
			}
		})

		// sort
		itemsArr.sort(function (a, b) {
			return a[1] == b[1] ? 0 : a[1] > b[1] ? 1 : -1
		})

		// put sorted html in tagswrap

		var markup = ''

		// first "clear all button"
		if ($tags_wrap.find('.deselect-tags').length > 0) {
			markup += $tags_wrap.find('.deselect-tags')[0].outerHTML
		}

		// then put active bubbles in markup
		$tags_wrap.find('.lay-tag-active').each(function () {
			markup += this.outerHTML
		})

		// then the inactive ones
		for (var index = 0; index < itemsArr.length; index++) {
			if (!itemsArr[index][0].classList.contains('deselect-tags')) {
				markup += itemsArr[index][0].outerHTML
			}
		}

		$tags_wrap.html(markup)
	}
}

var $target = undefined
var $lastTarget = undefined
var lastTypeOfContentThatIsReady = undefined
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		initGrids($target)

		lastTypeOfContentThatIsReady = typeOfContentThatIsReady
		$lastTarget = $target
	})

	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		initGrids($target)
	})

	window.laytheme.on('overlayhidden', function () {
		$target = getTargetContainersExceptPageOverlay(lastTypeOfContentThatIsReady)
		// dont need to do initGrids again, because this page's thumbnailgrid was already initialized
	})
}

var bindPageOverlayEvents = function () {}

// todo: do this for elementgrid and thumbnailgrid too
// lazySizes.autoSizer.checkElems()
utility_controller.setImageSizesAttribute($grids)

var initGrids = function ($target) {
	$grids = $target.find('.lay-products-thumbnails-grid')
	var $grids2 = $grids.not('.initialized')
	if ($grids2.length > 0) {
		$grids2.each(function () {
			var $grid = jQuery(this)

			var config = $grid.data('config')
			var cat_id = false
			initLayoutType($grid, config)
			sizeLayout($grid, config)
			var hash = window.location.hash
			var wasFiltered = false
			if (hash.startsWith('#product-category-') && jQuery(this).hasClass('use-filter')) {
				var slug = hash.substring(18)
				var $filter = jQuery(this.parentNode).find('[data-slug="' + slug + '"]')
				if ($filter.length > 0) {
					cat_id = $filter.attr('data-id')
					var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
					filterContent($grid, cat_id, false, thumbnails_show_hide_data)
					wasFiltered = true
				}
			}
			// filter by default category:
			if (!wasFiltered && jQuery(this).hasClass('use-filter')) {
				cat_id = jQuery(this.parentNode).find('.lay-filter-default.lay-filter-active').attr('data-id')
				var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
				filterContent($grid, cat_id, false, thumbnails_show_hide_data)
				wasFiltered = true
			} else {
				// were not using a filter, so we need to use the categories that are used in ['category'] in the config

				// Restore load more state from sessionStorage
				var elementType = restoreLoadMore.getElementType($grid)
				var elementId = restoreLoadMore.getElementId($grid)
				if (elementType && elementId) {
					if (!restoreLoadMore.isRememberEnabled()) {
						restoreLoadMore.clearLoadMoreState(elementType, elementId)
					} else {
						var savedState = restoreLoadMore.getLoadMoreState(elementType, elementId)
						if (savedState && savedState.multiplier && savedState.multiplier > 1) {
							setRowsShownMultiplier($grid, savedState.multiplier)
						}
					}
				}

				if (config.hasOwnProperty('category') && config.category != null) {
					var cat_array = []
					for (var index = 0; index < config.category.length; index++) {
						var cat_obj = config.category[index]
						if (cat_obj.hasOwnProperty('id')) {
							cat_array.push(cat_obj.id)
						}
					}
					if (cat_array.length > 0) {
						cat_id = cat_array
					}
				}
			}

			// hide tag bubbles that are not available
			if (cat_id !== false) {
				showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
			}
			// If not filtered, ensure applyRowLimit is called for Load More functionality
			if (!wasFiltered && !jQuery(this).hasClass('use-filter')) {
				applyRowLimit($grid, config)
			}
			$grid.addClass('initialized')
		})

		bindClearAllTagsClick()
		bindFilterClick()
		bindTagFilterClick()

		$grids2.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			initLayoutType($el, config)
			sizeLayout($el, config)
			jQuery(this).addClass('sized')
		})

		// lazySizes.autoSizer.checkElems()
		utility_controller.setImageSizesAttribute($grids2)
	}

	$grids.each(function () {
		var $col = jQuery(this).closest('.col')
		// in case were in customizer, filters may get reloaded, so we add initialized class here
		$col.find('.lay-productsgrid-tagfilter').addClass('initialized')
		$col.find('.lay-productsgrid-filter').addClass('initialized')
	})
}

var bindClearAllTagsClick = function () {
	jQuery(document).off('tap', '.lay-productsgrid-tagfilter .deselect-tags')
	jQuery(document).on('tap', '.lay-productsgrid-tagfilter .deselect-tags', function (e) {
		jQuery(this).addClass('lay-filter-hidden')
		var $col = jQuery(e.target.closest('.col'))
		var $grid = $col.find('.lay-products-thumbnails-grid')

		deselectTags($grid)

		var $active = $col.find('.lay-productsgrid-filter-anchor.lay-filter-active')
		var cat_id = false
		if ($active.length > 0) {
			cat_id = parseInt($col.find('.lay-productsgrid-filter-anchor.lay-filter-active').attr('data-id'), 10)
		}

		var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
		filterContent($grid, cat_id, true, thumbnails_show_hide_data)

		var config = $grid.data('config')
		var tagFilterBehaviour = 'OR'
		if (config != false && config.hasOwnProperty('tagFilterBehaviour') && config.tagFilterBehaviour != null) {
			tagFilterBehaviour = config.tagFilterBehaviour
			tagFilterBehaviour = tagFilterBehaviour.toUpperCase()
		}
		// show tag bubbles again
		if (tagFilterBehaviour == 'AND') {
			showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
		}
	})
}

var bindTagFilterClick = function () {
	jQuery(document).off('tap', '.lay-productsgrid-tagfilter .ptag-bubble:not(.deselect-tags)')
	jQuery(document).on('tap', '.lay-productsgrid-tagfilter .ptag-bubble:not(.deselect-tags)', function (e) {
		var $col = jQuery(e.target.closest('.col'))
		var $grid = $col.find('.lay-products-thumbnails-grid')

		var $tag_bubble = jQuery(this)
		var $tags_wrap = $col.find('.lay-productsgrid-tagfilter')
		var config = $grid.data('config')
		var reorder_tags = config != false && config.hasOwnProperty('reorder_tags') ? config.reorder_tags : true

		if (!$tag_bubble.hasClass('lay-tag-active')) {
			if (reorder_tags) {
				var $last_active_tag = $tags_wrap.find('.lay-tag-active').last()
				if ($last_active_tag.length > 0) {
					$tag_bubble.insertAfter($last_active_tag)
				} else {
					if ($col.find('.deselect-tags').length > 0) {
						$tag_bubble.insertAfter($col.find('.deselect-tags'))
					} else {
						$tags_wrap.prepend($tag_bubble)
					}
				}
			}
			$tag_bubble.addClass('lay-tag-active')
			// scroll to on mobile one line
			var oneline = $col[0].querySelector('.lay-productsgrid-tagfilter.mobile-one-line')

			var reorder = true
			if (config.hasOwnProperty('reorder_tags') && config.reorder_tags != null) {
				reorder = config.reorder_tags
			}

			if (oneline && reorder) {
				oneline.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth',
				})
			}
		} else {
			deselectTags($grid, $tag_bubble)
		}
		var $active = $col.find('.lay-productsgrid-filter-anchor.lay-filter-active')
		var cat_id = false
		if ($active.length > 0) {
			cat_id = parseInt($col.find('.lay-productsgrid-filter-anchor.lay-filter-active').attr('data-id'), 10)
		}

		var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
		filterContent($grid, cat_id, true, thumbnails_show_hide_data)
		showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
	})
}

var bindFilterClick = function () {
	jQuery(document).off('tap', '.lay-productsgrid-filter-anchor')
	jQuery(document).on('tap', '.lay-productsgrid-filter-anchor', function (e) {
		if (!jQuery(this).hasClass('lay-filter-active')) {
			// set hash, this way when going back using the browser button the same content will still be shown
			// and the state of the thumbnailgrid is shareable

			var slug = jQuery(this).attr('data-slug')
			window.location.hash = 'product-category-' + slug
		} else if (jQuery(e.delegateTarget).find('.lay-tag-active').length > 0) {
			// reset tag filter!
			handleHashChange()
		}
	})
}

var filterContent = function ($grid, cat_id, animate = true, thumbnails_show_hide_data = []) {
	$grid.parent().find('.lay-filter-active').removeClass('lay-filter-active')

	if (cat_id !== false) {
		$grid
			.parent()
			.find('.lay-productsgrid-filter-anchor[data-id="' + cat_id + '"]')
			.addClass('lay-filter-active')
	}

	var $thumbs = $grid.find('.lay-product')
	var config = $grid.data('config')

	// Hide Load More button immediately when filtering starts
	var $buttonWrap = $grid.find('.lay-productsgrid-load-more-wrap').first()
	if ($buttonWrap.length === 0) {
		$buttonWrap = $grid.parent().find('.lay-productsgrid-load-more-wrap').first()
	}
	if ($buttonWrap.length === 0) {
		$buttonWrap = $grid.nextAll('.lay-productsgrid-load-more-wrap').first()
	}
	if ($buttonWrap.length === 0) {
		$buttonWrap = $grid.closest('.col').find('.lay-productsgrid-load-more-wrap').first()
	}
	var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-productsgrid-load-more').first() : jQuery()
	if ($button.length > 0) {
		$button.hide()
	}

	// Reset Load More multiplier immediately when filtering starts
	resetRowsShownMultiplier($grid)

	if (layData.pgf_transition == 'fade_out_fade_in' && animate) {
		$grid.parent().addClass('lay-disable-click lay-transition')
		$grid.find('.lay-products').css('opacity', 0)
		setTimeout(function () {
			showHideThumbnails(thumbnails_show_hide_data)

			// re-layout
			switch (config.layoutType) {
				case 'masonry':
					sizeLayout($grid, config)
					break
				default:
					initLayoutType($grid, config)
					sizeLayout($grid, config)
					break
			}
			utility_controller.setImageSizesAttribute($grid)
			// Re-evaluate Load More button visibility after filtering and layout
			applyRowLimit($grid, config)
			var $filteredThumbs = $grid.find('.show-filtered')
			waitUntilInviewImagesHaveLoaded($filteredThumbs, function () {
				// show
				$grid.find('.lay-products').css('opacity', 1)
				setTimeout(function () {
					$grid.parent().removeClass('lay-disable-click lay-transition')
					// Re-evaluate button visibility after animation completes to ensure it's shown if needed
					applyRowLimit($grid, config)
				}, 500)
			})
			window.eventsChannel.emit('productsGridWasFiltered')
		}, 500)
	} else if (layData.pgf_transition == 'fade_out_fade_in_2' && animate) {
		// fade out all thumbnails at once
		// disable clicking filters
		// load thumbnails that are in viewport
		$grid.parent().addClass('lay-disable-click')

		$thumbs.css('transitionDelay', '0ms')
		$thumbs.removeClass('in-view').addClass('below')

		setTimeout(function () {
			showHideThumbnails(thumbnails_show_hide_data)

			// re-layout
			switch (config.layoutType) {
				case 'masonry':
					sizeLayout($grid, config)
					break
				default:
					initLayoutType($grid, config)
					sizeLayout($grid, config)
					break
			}
			utility_controller.setImageSizesAttribute($grid)
			// Re-evaluate Load More button visibility after filtering and layout - do this BEFORE setting transition delays
			applyRowLimit($grid, config)

			// Now get filtered thumbs and set transition delays only for visible ones (not hidden by loadmore)
			var $filteredThumbs = $grid.find('.show-filtered')
			// Clear all transition delays first
			$filteredThumbs.each(function () {
				jQuery(this)[0].style.transitionDelay = ''
			})
			// Only set delays for items that are visible (not hidden by loadmore)
			var visibleFilteredThumbs = $filteredThumbs.not('.hide-loadmore')
			var ix = 0
			// css animations
			// need to set transition delay here immediately. if i set it later, it might not work
			// because "element on scroll transition" intersection observer might remove "below" class and add "in-view" class before i set the delays
			visibleFilteredThumbs.each(function () {
				var $thumb = jQuery(this)
				if ($thumb.css('display') == 'block') {
					$thumb[0].style.transitionDelay = ix * 100 + 'ms'
					ix++
				}
			})

			waitUntilInviewImagesHaveLoaded($filteredThumbs, function () {
				// css animations - only animate items that are visible (not hidden by loadmore)
				var visibleFilteredThumbs = $filteredThumbs.not('.hide-loadmore')
				visibleFilteredThumbs.each(function () {
					var $thumb = jQuery(this)
					if ($thumb.css('display') == 'block') {
						// now show thumbnails
						$thumb.removeClass('below').addClass('in-view')
					} else {
						$thumb.removeClass('below in-view')
					}
				})
				// Hide items that are hidden by loadmore
				$filteredThumbs.filter('.hide-loadmore').each(function () {
					jQuery(this).removeClass('below in-view')
				})
				$grid.parent().removeClass('lay-disable-click')
				// Re-evaluate button visibility after animation completes to ensure it's shown if needed
				applyRowLimit($grid, config)
			})
			window.eventsChannel.emit('productsGridWasFiltered')
		}, 550)
	} else {
		showHideThumbnails(thumbnails_show_hide_data)

		switch (config.layoutType) {
			case 'masonry':
				sizeLayout($grid, config)
				break
			default:
				initLayoutType($grid, config)
				sizeLayout($grid, config)
				break
		}
		utility_controller.setImageSizesAttribute($grid)
		// Re-evaluate Load More button visibility after filtering and layout
		applyRowLimit($grid, config)
		window.eventsChannel.emit('productsGridWasFiltered')
	}
}

var get_thumbnails_show_hide_data = function ($grid) {
	var hash = window.location.hash
	var cat_id = false
	if (hash.startsWith('#product-category-')) {
		var slug = hash.substring(18)
		var $filter = jQuery('[data-slug="' + slug + '"]')
		if ($filter.length > 0) {
			cat_id = parseInt($filter.attr('data-id'), 10)
		}
	} else if (hash == '') {
		// back to default filter!

		// todo:
		var $filter = jQuery('.lay-filter-default')
		if ($filter.length > 0) {
			cat_id = parseInt($filter.attr('data-id'), 10)
		}
	}
	var tag_ids_to_filter_for = []
	var $col = $grid.closest('.col')
	$col.find('.ptag-bubble.lay-tag-active').each(function () {
		var tag_id = parseInt(jQuery(this).attr('data-tag_id'), 10)
		tag_ids_to_filter_for.push(tag_id)
	})

	var $thumbs = $grid.find('.lay-product>a')

	var config = $grid.data('config')
	// $thumbs, cat_id, tag_ids_to_filter_for = [], config = false
	var data = []

	var tagFilterBehaviour = 'OR'
	if (config != false && config.hasOwnProperty('tagFilterBehaviour') && config.tagFilterBehaviour != null) {
		tagFilterBehaviour = config.tagFilterBehaviour
		tagFilterBehaviour = tagFilterBehaviour.toUpperCase()
	}

	$thumbs.each(function () {
		var $thumb = jQuery(this)
		var thumbnail_tag_ids_string = $thumb.attr('data-tags')
		var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)

		var thumbnail_category_ids_string = $thumb.attr('data-catid')
		var thumbnail_category_ids = utility_controller.parseIdsString(thumbnail_category_ids_string)

		var resultObj = {
			show: false,
			$el: $thumb.parent(),
			ids: thumbnail_tag_ids,
		}

		var tagIntersection = false
		switch (tagFilterBehaviour) {
			case 'AND':
				tagIntersection = intersection(thumbnail_tag_ids, tag_ids_to_filter_for).length == tag_ids_to_filter_for.length
				break
			case 'OR':
			default:
				tagIntersection = intersection(thumbnail_tag_ids, tag_ids_to_filter_for).length > 0
				break
		}

		var isCatMember = thumbnail_category_ids.indexOf(cat_id) !== -1

		if (tag_ids_to_filter_for.length == 0 && cat_id !== false && isCatMember) {
			resultObj.show = true
		} else if (tag_ids_to_filter_for.length > 0 && tagIntersection && cat_id !== false && isCatMember) {
			resultObj.show = true
		} else if (tag_ids_to_filter_for.length > 0 && tagIntersection && cat_id === false) {
			resultObj.show = true
		} else if (cat_id === false && tag_ids_to_filter_for.length == 0) {
			resultObj.show = true
		} else {
			resultObj.show = false
		}

		data.push(resultObj)
	})

	return data
}

var showHideThumbnails = function (thumbnails_show_hide_data) {
	for (var index = 0; index < thumbnails_show_hide_data.length; index++) {
		var obj = thumbnails_show_hide_data[index]
		if (obj.show == true) {
			obj.$el.css('display', 'block').addClass('show-filtered').removeClass('hide-filtered')
		} else {
			obj.$el.css('display', 'none').addClass('hide-filtered').removeClass('show-filtered')
		}
	}
}

var arrayElIsTrue = function (element, index, array) {
	return element == true
}

var waitUntilInviewImagesHaveLoaded = function ($thumbs, callback) {
	var imagesInViewport = []
	var imagesInViewportHaveLoaded = []

	$thumbs.find('img').each(function () {
		if (load_visible_images_then_rest_controller.isInsideViewportHeight(this, 90)) {
			imagesInViewport.push(this)
			imagesInViewportHaveLoaded.push(false)
		}
	})

	for (var i = 0; i < imagesInViewport.length; i++) {
		;(function (index) {
			var $img = jQuery(imagesInViewport[index])
			if ($img.hasClass('loaded') || $img.hasClass('lazyloaded') || $img.hasClass('woocommerce-placeholder')) {
				imagesInViewportHaveLoaded[index] = true
			} else {
				// wait until image gets the loaded or lazyloaded class
				var observer = new MutationObserver(() => {
					if ($img.hasClass('loaded') || $img.hasClass('lazyloaded')) {
						imagesInViewportHaveLoaded[index] = true
					}
				})
				observer.observe($img[0], { attributes: true, attributeFilter: ['class'] })
			}
		})(i)
	}
	if (imagesInViewport.length > 0) {
		var interval = setInterval(function () {
			// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/every
			if (imagesInViewportHaveLoaded.every(arrayElIsTrue)) {
				callback()
				clearInterval(interval)
			}
		}, 30)
	} else {
		callback()
	}
}

var onResize = function () {
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			sizeLayout($el, config)
		})
	}
}

var sizeLayout = function ($el, config) {
	var currentDevice = Utility.screenSize

	var colGutter = config[currentDevice].colGutter
	var colCount = config[currentDevice].colCount

	var rowGutterMu = typeof config[currentDevice].rowGutterMu === 'undefined' ? '%' : config[currentDevice].rowGutterMu
	var colGutterMu = typeof config[currentDevice].colGutterMu === 'undefined' ? '%' : config[currentDevice].colGutterMu

	// took this calculation from "layout_functions.php"
	var gutter_diff = (1 - 1 / colCount) * config[currentDevice].colGutter
	var width = 'calc( 100% / ' + colCount + ' - ' + gutter_diff + colGutterMu + ')'

	$el.find('li').css({
		width: width,
		'margin-bottom': config[currentDevice].rowGutter + rowGutterMu,
		// 'margin-bottom': 0,
		'margin-left': 0,
	})

	var layoutType = config.layoutType
	switch (layoutType) {
		case 'masonry':
			$el.find('.lay-productsgrid-gutter-sizer').css('width', colGutter + colGutterMu)
			$el.find('.lay-productsgrid-col-sizer').css('width', width)
			var masonry = $el.data('masonry')
			if (typeof masonry != 'undefined') {
				masonry.layout()
			}
			break
		default:
			// just flexbox
			$el.find('.lay-products').css('gap', colGutter + colGutterMu)
			break
	}
	applyRowLimit($el, config)
}

var initLayoutType = function ($el, config) {
	switch (config.layoutType) {
		case 'masonry':
			var elem = $el.find('ul.lay-products')[0]

			var masonry = new Masonry(elem, {
				// options
				itemSelector: 'li',
				columnWidth: '.lay-productsgrid-col-sizer',
				gutter: '.lay-productsgrid-gutter-sizer',
				percentPosition: true,
				transitionDuration: 0,
				horizontalOrder: true,
			})
			masonry.once('layoutComplete', function () {
				$el.closest('.col').addClass('masonry-initialized')
			})
			$el.data('masonry', masonry)
			break
		default:
			break
	}
}

jQuery(document).on('click', '.lay-productsgrid-load-more', function (event) {
	event.preventDefault()
	var $button = jQuery(this)
	var $buttonWrap = $button.closest('.lay-productsgrid-load-more-wrap')
	// Find the grid - it should be a sibling or in the same parent container
	var $grid = $buttonWrap.siblings('.lay-products-thumbnails-grid').first()
	if ($grid.length === 0) {
		// Fallback: look in parent
		$grid = $buttonWrap.parent().find('.lay-products-thumbnails-grid').first()
	}
	if ($grid.length === 0) {
		return
	}
	var config = $grid.data('config')
	if (!config) {
		$button.hide()
		return
	}
	var rowsToShow = getLimitForDevice(config, Utility.screenSize)
	if (rowsToShow <= 0) {
		$button.hide()
		return
	}
	var multiplier = getRowsShownMultiplier($grid) + 1
	setRowsShownMultiplier($grid, multiplier)

	// Save load more state to sessionStorage
	var elementType = restoreLoadMore.getElementType($grid)
	var elementId = restoreLoadMore.getElementId($grid)
	if (elementType && elementId) {
		if (restoreLoadMore.isRememberEnabled()) {
			restoreLoadMore.saveLoadMoreState(elementType, elementId, { multiplier: multiplier })
		} else {
			restoreLoadMore.clearLoadMoreState(elementType, elementId)
		}
	}

	applyRowLimit($grid, config)
	sizeLayout($grid, config)
	// Find the container for setImageSizesAttribute
	var $container = $grid.closest('.col')
	if ($container.length > 0) {
		utility_controller.setImageSizesAttribute($container)
	}

	// Scroll animations are handled automatically by the IntersectionObserver:
	// Hidden elements already have the 'below' class from initial setup,
	// so when they become visible, the observer will automatically trigger the animation

	// Check if button should be hidden (all items shown)
	if ($grid.find('.lay-product').not('.hide-filtered, .hide-because-limit, .hide-loadmore').length === $grid.find('.lay-product').not('.hide-filtered, .hide-because-limit').length) {
		$button.hide()
	}
})

var productsgrid_controller_new = {
	sizeLayout: sizeLayout,
	i: i,
}

export default productsgrid_controller_new

window.productsgrid_controller_new = productsgrid_controller_new
